/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _also_discover_our_platforms_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Découvrez aussi nos plateformes' }],
    'fr',
);

const _also_discover_our_platforms_en = new IntlMessageFormat(
    [{ type: 0, value: 'Also discover our platforms' }],
    'en',
);

export function also_discover_our_platforms(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _also_discover_our_platforms_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _also_discover_our_platforms_en.format(args) as unknown as string;
    }

    return _also_discover_our_platforms_fr.format(args) as unknown as string;
}

const _afrikad_desc_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Régie publicitaire Africaine.' }],
    'fr',
);

const _afrikad_desc_en = new IntlMessageFormat(
    [{ type: 0, value: 'African advertising agency.' }],
    'en',
);

export function afrikad_desc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _afrikad_desc_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _afrikad_desc_en.format(args) as unknown as string;
    }

    return _afrikad_desc_fr.format(args) as unknown as string;
}

const _mapitoo_desc_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Sites dédiés: la connaissance à portée de main' }],
    'fr',
);

const _mapitoo_desc_en = new IntlMessageFormat(
    [{ type: 0, value: 'Dedicated sites: knowledge at your fingertips' }],
    'en',
);

export function mapitoo_desc(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _mapitoo_desc_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _mapitoo_desc_en.format(args) as unknown as string;
    }

    return _mapitoo_desc_fr.format(args) as unknown as string;
}

const _africa_directory_fr = new IntlMessageFormat(
    [{ type: 0, value: "Annuaire d'Afrique" }],
    'fr',
);

const _africa_directory_en = new IntlMessageFormat(
    [{ type: 0, value: 'Africa Directory' }],
    'en',
);

export function africa_directory(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _africa_directory_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _africa_directory_en.format(args) as unknown as string;
    }

    return _africa_directory_fr.format(args) as unknown as string;
}

const _footer_text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: '[b]Portail de l\'internet Africain[/b] et [b]annuaire pages jaunes des entreprises Africaines[/b]\n[br /]\nCe site est 100% "made in Africa" et vous propose ses nombreux services en ligne.\n',
        },
    ],
    'fr',
);

const _footer_text_en = new IntlMessageFormat(
    [
        {
            type: 0,
            value: '[b]African internet portal[/b] and [b]yellow pages directory of African businesses[/b]\n[br /]\nThis site is 100% "made in Africa" and offers you its many online services.\n',
        },
    ],
    'en',
);

export function footer_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _footer_text_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _footer_text_en.format(args) as unknown as string;
    }

    return _footer_text_fr.format(args) as unknown as string;
}

const _information_and_links_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Infos & liens' }],
    'fr',
);

const _information_and_links_en = new IntlMessageFormat(
    [{ type: 0, value: 'Information & Links' }],
    'en',
);

export function information_and_links(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _information_and_links_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _information_and_links_en.format(args) as unknown as string;
    }

    return _information_and_links_fr.format(args) as unknown as string;
}

const _who_are_we_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Qui sommes nous ?' }],
    'fr',
);

const _who_are_we_en = new IntlMessageFormat([{ type: 0, value: 'Who are we?' }], 'en');

export function who_are_we(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _who_are_we_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _who_are_we_en.format(args) as unknown as string;
    }

    return _who_are_we_fr.format(args) as unknown as string;
}

const _employment_by_profession_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Emploi par métier' }],
    'fr',
);

const _employment_by_profession_en = new IntlMessageFormat(
    [{ type: 0, value: 'Employment by profession' }],
    'en',
);

export function employment_by_profession(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _employment_by_profession_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _employment_by_profession_en.format(args) as unknown as string;
    }

    return _employment_by_profession_fr.format(args) as unknown as string;
}

const _faq_fr = new IntlMessageFormat([{ type: 0, value: 'FAQ' }], 'fr');

const _faq_en = new IntlMessageFormat([{ type: 0, value: 'FAQ' }], 'en');

export function faq(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _faq_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _faq_en.format(args) as unknown as string;
    }

    return _faq_fr.format(args) as unknown as string;
}

const _legal_notice_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Mentions légales' }],
    'fr',
);

const _legal_notice_en = new IntlMessageFormat(
    [{ type: 0, value: 'Legal notice' }],
    'en',
);

export function legal_notice(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _legal_notice_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _legal_notice_en.format(args) as unknown as string;
    }

    return _legal_notice_fr.format(args) as unknown as string;
}

const _privacy_policy_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Politique de confidentialité' }],
    'fr',
);

const _privacy_policy_en = new IntlMessageFormat(
    [{ type: 0, value: 'Privacy policy' }],
    'en',
);

export function privacy_policy(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _privacy_policy_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _privacy_policy_en.format(args) as unknown as string;
    }

    return _privacy_policy_fr.format(args) as unknown as string;
}

const _cgu_fr = new IntlMessageFormat([{ type: 0, value: 'CGU' }], 'fr');

const _cgu_en = new IntlMessageFormat([{ type: 0, value: 'Terms and conditions' }], 'en');

export function cgu(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _cgu_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _cgu_en.format(args) as unknown as string;
    }

    return _cgu_fr.format(args) as unknown as string;
}

const _contact_fr = new IntlMessageFormat([{ type: 0, value: 'Contact' }], 'fr');

const _contact_en = new IntlMessageFormat([{ type: 0, value: 'Contact' }], 'en');

export function contact(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _contact_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _contact_en.format(args) as unknown as string;
    }

    return _contact_fr.format(args) as unknown as string;
}

const _news_fr = new IntlMessageFormat([{ type: 0, value: 'Nouveautés' }], 'fr');

const _news_en = new IntlMessageFormat([{ type: 0, value: 'News' }], 'en');

export function news(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _news_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _news_en.format(args) as unknown as string;
    }

    return _news_fr.format(args) as unknown as string;
}

const _new_companies_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Nouvelles sociétés' }],
    'fr',
);

const _new_companies_en = new IntlMessageFormat(
    [{ type: 0, value: 'New companies' }],
    'en',
);

export function new_companies(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _new_companies_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _new_companies_en.format(args) as unknown as string;
    }

    return _new_companies_fr.format(args) as unknown as string;
}

const _last_comments_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Derniers commentaires' }],
    'fr',
);

const _last_comments_en = new IntlMessageFormat(
    [{ type: 0, value: 'Latest comments' }],
    'en',
);

export function last_comments(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _last_comments_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _last_comments_en.format(args) as unknown as string;
    }

    return _last_comments_fr.format(args) as unknown as string;
}

const _blog_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Blog GoAfrica Online' }],
    'fr',
);

const _blog_en = new IntlMessageFormat(
    [{ type: 0, value: 'GoAfrica Online Blog' }],
    'en',
);

export function blog(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _blog_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _blog_en.format(args) as unknown as string;
    }

    return _blog_fr.format(args) as unknown as string;
}
